import Box from '@mui/material/Box';
import { InlineQuillEdit } from '../InlineQuillEdit';
import LessonComponentService from '../../services/LessonComponentService';
import { LessonComponentStyleType } from '../../models/LessonComponentStyleType';
import { LessonContextConsumer } from '../../models/LessonContext';
import NewComponentService from '../../services/NewComponentService';
import React from 'react';
import componentStyles from '../../styles/LessonComponents.module.css';

interface ItemEditorProps {
  styleType: LessonComponentStyleType;
  componentkey: number;
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onClick?: (index: string, value: string) => void;
  isCenterAligned?: boolean;
}

export default function ItemEditor(props: ItemEditorProps) {
  return (
    <LessonContextConsumer>
      {({ mode }) => (
        <div
          className={`style-${props.styleType} ${
            props.isCenterAligned && 'center-placeholder'
          }`}
          style={{ zIndex: 1000 }}
        >
          <Box className={componentStyles.textOverflow}>
            {mode === 'edit' ? (
              <InlineQuillEdit
                placeholder={props.placeholder}
                value={
                  props.value ||
                  (props.isCenterAligned
                    ? NewComponentService.centeredText
                    : '')
                }
                componentKey={props.componentkey}
                styleType={props.styleType}
                isCenterAligned={!!props.isCenterAligned}
                onChange={props.onChange}
                onClick={props.onClick}
              />
            ) : (
              <span
                className="ql-editor"
                dangerouslySetInnerHTML={{
                  __html: LessonComponentService.getUrlWithSas(props.value)
                }} //value has been sanitized before storing into db.
              ></span>
            )}
          </Box>
        </div>
      )}
    </LessonContextConsumer>
  );
}
